import createCachedSelector from 're-reselect';
import {RootState} from '../../rootReducer';
import {NodeOnDateSelectorProps} from '../../util/buildingNodes/types';
import {isNodeClosed} from './helpers';
import {getBuildingEntities, getTotalBuildings} from '../buildings/selectors';
import {getFloorEntities} from '../floors/selectors';
import {getAreaEntities} from '../areas/selectors';

export const getAllOpeningDaysExceptions = (state: RootState) => state.data.openingDays.openingDaysExceptions;

export const getIsNodeClosed = createCachedSelector(
  getBuildingEntities,
  getFloorEntities,
  getAreaEntities,
  getAllOpeningDaysExceptions,
  (_state: RootState, props: NodeOnDateSelectorProps) => props,
  (buildings, floors, areas, openingDaysExceptions, {nodeId, date}) => {
    return isNodeClosed({
      nodeId,
      date,
      buildings,
      floors,
      areas,
      openingDaysExceptions,
    });
  },
)((_state, {date, nodeId}) => `${nodeId}:${date?.toISOString() || ''}`);

export const getAreAllNodesClosed = createCachedSelector(
  getTotalBuildings,
  getBuildingEntities,
  getFloorEntities,
  getAreaEntities,
  getAllOpeningDaysExceptions,
  (_state: RootState, date: Date | undefined) => date,
  (buildingCount, buildings, floors, areas, openingDaysExceptions, date) => {
    if (!buildingCount) return false;
    return Object.values(buildings).every((building) => {
      if (!building) {
        return false;
      }

      return isNodeClosed({
        nodeId: building.id,
        date,
        buildings,
        floors,
        areas,
        openingDaysExceptions,
      });
    });
  },
)((_, date) => date?.toISOString() || '');

export const getIsLoadingOpeningDaysExceptions = (state: RootState) => state.data.openingDays.isLoading;
